module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/67f20864e89390c2b7520695b9a8a0eb.png";